const createMap = (dict, def = '--') => {
	return (v) => {
		if (v in dict) {
			return dict[v];
		}
		console.warn('can not found %s in dict', v, dict);
		return def;
	};
};

// mode 模板hash表, isNumber key是否为数字类型
const createModelList = (mode, isNumber = true) => {
	return [
		{
			value: '',
			label: '全部',
		},
		...Object.keys(mode).map((key) => {
			return {
				value: isNumber ? +key : key,
				label: mode[key],
			};
		}),
	];
};
// 付费类型
export const PAY_TYPES = {
	FLAGSHIP: 0,
	MAJOR: 1,
	RAISE: 2,
};
export const PAY_TYPES_MAP = {
	[PAY_TYPES.FLAGSHIP]: '旗舰版',
	[PAY_TYPES.MAJOR]: '专业版',
	[PAY_TYPES.RAISE]: '扩容延时包',
};

export const PAY_TYPES_FUN = createMap(PAY_TYPES_MAP);

// 收入类型
export const INCOME_TYPES = {
	REWARD: 0,
	WITHDRAWAL: 1,
	NORMAL_REDPACKET: 2,
	PIN_REDPACKET: 3,
	REDPACKET_RETURN: 4,
	PAYVIEW: 5,
	PAYVdOWNLOAD: 6,
	DRAWBACK: 7,
	BATCHES: 8,
	DISCOUNT: 9,
	BALANCEDEDUCTION: 10,
	GIFT: 11,
	REDPACKETRAIN: 12,
	GUESSFORGIFT: 13,
	INVEST: 14,
	DEDUCATIONFORGUEST: 15, // 嘉宾连麦扣款（充值金额）
	RECHARGEDEDUCATION: 16,
	DEDUCATIONFORGUEST2: 17, // 嘉宾连麦扣款（收益余额）
	REPAYMENT: 18,
	REPAYMENT2: 19,
	REWARDS: 20,
	REWARDS2: 21,
	ALBUMINCOME: 22,
	INVITE_REWARD: 23,
	INCOME_RECHARGE: 24,
	RAIN_REFUND: 25,
	OFFLINE_RECHARGE: 26,
	SERVICES_CHARGE: 27,
	TURNTABLE_REDPACKET: 28,
	TURNTABLE_REDPACKET_PAYBACK: 29,
	PROMOTER_WITHDRAWAL: 32,
	SHAKEGAME_PAYBACK: 33,
	SHAKEGAME: 34,
};
export const INCOME_TYPES_MAP = {
	[INCOME_TYPES.REWARD]: '收到打赏',
	[INCOME_TYPES.WITHDRAWAL]: '提现',
	[INCOME_TYPES.PROMOTER_WITHDRAWAL]: '推广员提现',
	[INCOME_TYPES.NORMAL_REDPACKET]: '普通红包',
	[INCOME_TYPES.PIN_REDPACKET]: '拼手气红包',
	[INCOME_TYPES.REDPACKET_RETURN]: '红包退回',
	[INCOME_TYPES.PAYVIEW]: '付费观看',
	[INCOME_TYPES.PAYVdOWNLOAD]: '付费下载',
	[INCOME_TYPES.DRAWBACK]: '提现退款',
	[INCOME_TYPES.BATCHES]: '订单分销',
	[INCOME_TYPES.DISCOUNT]: '代理收益提现',
	[INCOME_TYPES.BALANCEDEDUCTION]: '余额抵扣',
	[INCOME_TYPES.GIFT]: '礼物',
	[INCOME_TYPES.REDPACKETRAIN]: '红包雨',
	[INCOME_TYPES.GUESSFORGIFT]: '答题竞猜',
	[INCOME_TYPES.INVEST]: '充值',
	[INCOME_TYPES.DEDUCATIONFORGUEST]: '嘉宾连麦扣款',
	[INCOME_TYPES.RECHARGEDEDUCATION]: '余额抵扣',
	[INCOME_TYPES.DEDUCATIONFORGUEST2]: '嘉宾连麦扣款',
	[INCOME_TYPES.REPAYMENT]: '账户还款',
	[INCOME_TYPES.REPAYMENT2]: '账户还款',
	[INCOME_TYPES.REWARDS]: '观看奖励',
	[INCOME_TYPES.REWARDS2]: '观看奖励',
	[INCOME_TYPES.ALBUMINCOME]: '合集付费',
	[INCOME_TYPES.INVITE_REWARD]: '邀请奖励',
	[INCOME_TYPES.INCOME_RECHARGE]: '收益充值',
	[INCOME_TYPES.RAIN_REFUND]: '红包雨退款',
	[INCOME_TYPES.OFFLINE_RECHARGE]: '对公转账',
	[INCOME_TYPES.SERVICES_CHARGE]: '扣除手续费',
	[INCOME_TYPES.TURNTABLE_REDPACKET]: '转盘红包',
	[INCOME_TYPES.TURNTABLE_REDPACKET_PAYBACK]: '转盘红包退款',
	[INCOME_TYPES.SHAKEGAME]: '单人摇一摇',
	[INCOME_TYPES.SHAKEGAME_PAYBACK]: '单人摇一摇退款',
};

export const INCOME_TYPES_FUN = createMap(INCOME_TYPES_MAP);

export const INCOME_TYPES_LIST = createModelList(INCOME_TYPES_MAP, false);
// 付费二级类型
export const PAY_INFO_TYPES = {
	// 专业版
	MAJOR_YEAR: 1,
	MAJOR_TEN: 2,
	MAJOR_ONE: 3,
	// 旗舰版
	FLAGSHIP_YEAR_INFINITE: 12,
	FLAGSHIP_YEAR: 13,
	FLAGSHIP_TEN: 14,
	FLAGSHIP_ONE: 15,
	// 延时
	RAISE_MEDIA: 16,
	RAISE_REPLAY: 17,
	RAISE_FLOW: 18,
	// 企业版
	FLAG_COMPANY: 19,
	FULLVIEW_COMPANY: 20,
};

export const PAY_INFO_TYPES_MAP = {
	[PAY_INFO_TYPES.MAJOR_YEAR]: '年费会员',
	[PAY_INFO_TYPES.MAJOR_TEN]: '十场会员',
	[PAY_INFO_TYPES.MAJOR_ONE]: '单场会员',
	[PAY_INFO_TYPES.FLAGSHIP_YEAR_INFINITE]: '无限流量年费',
	[PAY_INFO_TYPES.FLAGSHIP_YEAR]: '年费会员',
	[PAY_INFO_TYPES.FLAGSHIP_TEN]: '十场会员',
	[PAY_INFO_TYPES.FLAGSHIP_ONE]: '单场会员',
	[PAY_INFO_TYPES.RAISE_MEDIA]: '媒体库扩容100GB/年',
	[PAY_INFO_TYPES.RAISE_REPLAY]: '回放延时30天',
	[PAY_INFO_TYPES.RAISE_FLOW]: '推流延时12小时',
	[PAY_INFO_TYPES.FLAG_COMPANY]: '企业版/年',
	[PAY_INFO_TYPES.FULLVIEW_COMPANY]: '企业版/年',
};

export const PAY_INFO_TYPES_FUN = createMap(PAY_INFO_TYPES_MAP);

// 录制结果
export const RECORD_TYPES = {
	FAILED: 0,
	WAITENCODE: 1,
	SUCCESS: 2,
	CONCATSTART: 3,
	CONCATOK: 4,
	CONCATFAILED: 5,
	ENCODEING: 6,
	UPLOADSUCCESS: 7,
	CLIPFAILED: 8,
	CLIPSUCCESS: 9,
	ENCODEFAILED: 10,
	UPLOADSUCCESSSTARTCODE: 11,
	UPLOADSUCCESSFAILCODE: 12,
	CLIPSUCCESSSTARTCODE: 13,
	CLIPSUCCESSFAILCODE: 14,
	DOWNLOADSTARTCODE: 15,
	CLIPFAILEDCODE: 16,
};

// export const RECORD_TYPES_MAP = {
// 	[RECORD_TYPES.FAILED]: '原片录制失败',
// 	[RECORD_TYPES.WAITENCODE]: '原片录制成功,待转码',
// 	[RECORD_TYPES.SUCCESS]: '原片录制成功',
// 	[RECORD_TYPES.CONCATSTART]: '视频合成开始',
// 	[RECORD_TYPES.CONCATOK]: '视频合成成功',
// 	[RECORD_TYPES.CONCATFAILED]: '视频合成失败',
// 	[RECORD_TYPES.ENCODEING]: '转码中',
// 	[RECORD_TYPES.UPLOADSUCCESS]: '视频上传成功',
// 	[RECORD_TYPES.CLIPFAILED]: '视频剪辑失败',
// 	[RECORD_TYPES.CLIPSUCCESS]: '视频剪辑成功',
// 	[RECORD_TYPES.ENCODEFAILED]: '视频转码失败',
// 	[RECORD_TYPES.UPLOADSUCCESSSTARTCODE]: '视频转码中',
// 	[RECORD_TYPES.UPLOADSUCCESSFAILCODE]: '视频上传成功，转码失败',
// 	[RECORD_TYPES.CLIPSUCCESSSTARTCODE]: '视频精剪成功，转码中',
// 	[RECORD_TYPES.CLIPSUCCESSFAILCODE]: '视频精剪成功，转码失败',
// };
export const RECORD_TYPES_MAP = {
	[RECORD_TYPES.FAILED]: '原片录制失败',
	[RECORD_TYPES.WAITENCODE]: '转码中', // 1
	[RECORD_TYPES.SUCCESS]: '原片录制成功',
	[RECORD_TYPES.CONCATSTART]: '合成中', // 3
	[RECORD_TYPES.CONCATOK]: '合成成功',
	[RECORD_TYPES.CONCATFAILED]: '合成失败',
	[RECORD_TYPES.ENCODEING]: '转码中', // 6
	[RECORD_TYPES.UPLOADSUCCESS]: '上传成功',
	[RECORD_TYPES.CLIPFAILED]: '剪辑失败',
	[RECORD_TYPES.CLIPSUCCESS]: '剪辑成功',
	[RECORD_TYPES.ENCODEFAILED]: '转码失败',
	[RECORD_TYPES.UPLOADSUCCESSSTARTCODE]: '转码中', // 11
	[RECORD_TYPES.UPLOADSUCCESSFAILCODE]: '上传成功，转码失败',
	[RECORD_TYPES.CLIPSUCCESSSTARTCODE]: '云剪辑成功，转码中', // 13
	[RECORD_TYPES.CLIPSUCCESSFAILCODE]: '云剪辑成功，转码失败',
	[RECORD_TYPES.DOWNLOADSTARTCODE]: '云剪辑生成中', // 15
	[RECORD_TYPES.CLIPFAILEDCODE]: '云剪辑生成失败',
};

export const RECORD_TYPES_FUN = createMap(RECORD_TYPES_MAP);

// 视频类型
export const VIDEO_TYPES = {
	ORIGIN: 1,
	ORIGINCONCAT: 2,
	UOLOAD: 3,
	CLIP: 4,
	FINECUT: 5,
};
export const VIDEO_TYPES_MAP = {
	[VIDEO_TYPES.ORIGIN]: '录制原片',
	[VIDEO_TYPES.ORIGINCONCAT]: '快剪视频',
	[VIDEO_TYPES.UOLOAD]: '上传视频',
	[VIDEO_TYPES.CLIP]: '快剪视频',
	[VIDEO_TYPES.FINECUT]: '云剪视频',
};
export const VIDEO_TYPES_FUN = createMap(VIDEO_TYPES_MAP);

// 付费会员
export const PAYVIP_TYPES = {
	FREE: 0,
	MAJOR: 1,
	FLAGSHIP: 2,
	// FLAGSHIP_INF: 3
};
export const PAYVIP_TYPES_MAP = {
	[PAYVIP_TYPES.FREE]: '免费版',
	[PAYVIP_TYPES.MAJOR]: '专业版',
	[PAYVIP_TYPES.FLAGSHIP]: '旗舰版',
	// [PAYVIP_TYPES.FLAGSHIP_INF]: '无限旗舰版'
};
export const PAYVIP_TYPES_FUN = createMap(PAYVIP_TYPES_MAP);

// 付费会员class名
export const PAYCLASS_TYPES = {
	FREE: 0,
	MAJOR: 1,
	FLAGSHIP: 2,
	// FLAGSHIP_INF: 3
};
export const PAYCLASS_TYPES_MAP = {
	[PAYVIP_TYPES.FREE]: 'free',
	[PAYVIP_TYPES.MAJOR]: 'major',
	[PAYVIP_TYPES.FLAGSHIP]: 'flagship',
	// [PAYVIP_TYPES.FLAGSHIP_INF]: 'flagship'
};
export const PAYCLASS_TYPES_FUN = createMap(PAYCLASS_TYPES_MAP);

// 购买时间类型
export const TIME_TYPES = {
	YEAR: 1,
	SCENE: 2,
	HOURS: 4,
	FOREVER: 9,
};
export const TIME_TYPES_MAP = {
	[TIME_TYPES.YEAR]: '包年',
	[TIME_TYPES.SCENE]: '包场次',
	[TIME_TYPES.HOURS]: '视频小时包',
	[TIME_TYPES.FOREVER]: '永久',
};
export const TIME_TYPES_FUN = createMap(TIME_TYPES_MAP, '包场次');

// 邀请奖励 -> 活动类型
export const INVITE_TYPE = {
	1: '邀请领现金',
	2: '邀请领卡券',
};

// 邀请奖励 -> 活动状态
export const LIVE_STATUS = {
	0: '未开始',
	1: '进行中',
	2: '已结束',
};

// 邀请奖励 -> 参与详情 -> 奖励状态
export const RECEIVED_AWARD = {
	0: '未获奖励',
	1: '已获奖励',
};

export const INVITE_TYPE_LIST = createModelList(INVITE_TYPE);

export const LIVE_STATUS_LIST = createModelList(LIVE_STATUS);

export const RECEIVED_AWARD_LIST = createModelList(RECEIVED_AWARD);

// 不能用Symbol
export const RECHARGE_SUCCESS = 'RECHARGE_SUCCESS';

//两个判断条件模式不同

//登陆需要
export const PHONEREG = /^1\d{10}$/;
export const MAXTIMES = 3;

export const ROLES_ENUM = {
	SUB_MANAGE: 11, //账号管理员
	LIVE_MANAGE: 21, //直播间管理员
	LIVE_PUBLISH: 31, //直播间发布员
	PHOTOGRAPHER: 32, //摄影师
	RETOUCHER: 33, //修图师
};
//子账号设置,角色列表
export const USER_DESCRIBE = [
	{
		value: ROLES_ENUM.SUB_MANAGE,
		name: '账号管理员',
		describe: '账号管理员可以管理该主账号下所有专辑、直播间、媒体库、敏感词库、奖池题库、门户网站、商城的相关内容',
		manage: '所有内容',
	},
	{
		value: ROLES_ENUM.LIVE_MANAGE,
		name: '直播间管理员',
		describe: '直播间管理员可以管理绑定专辑或直播间的相关内容',
		manage: '选择直播间',
	},
	// {
	// 	value: ROLES_ENUM.LIVE_PUBLISH,
	// 	name: '图文发布员',
	// 	describe: '图文发布员拥有图文直播的发布权限',
	// 	manage: '选择直播间',
	// },
	{
		value: ROLES_ENUM.PHOTOGRAPHER,
		name: '摄影师',
		describe: '摄影师没有后台访问权限，可以登录云摄影App上传图片',
		manage: '选择直播间',
	},
	{
		value: ROLES_ENUM.RETOUCHER,
		name: '修图师',
		describe: '修图师拥有照片管理权限，可以对照片进行下载、修图、上传等操作',
		manage: '选择直播间',
	},
];

// 收入类型
export const CONST_NUMBER = {
	FREE_SCENE: 300,
};

// 观看终端
export const PLATEFORM_TYPE = {
	1: 'pc端',
	2: '移动端浏览器',
	3: '微信电脑版',
	4: '微信手机版',
	5: '微信小程序',
	0: '未知',
};
